import React, {useContext} from "react";
import {useHttp} from "../../../hooks";
import MapperFlow from "../../MapperFlow";
import {ComponentLoader} from "../../UI";
import UIContext from "../../../storage/UIContext";
import PostContext from "../../../storage/PostContext";
import {Args, UseHttpResponse} from "../../../hooks/use-http/interfaces";
import DynamicObject from "../../../models/dynamic-object";
import LanguageContext from "../../../storage/LanguageContext";
import {configDraftApi, configNextApi} from '../../../config/api.config'
import FlowReferences from "../../../flow-references";


interface Props {

    Previous: React.FunctionComponent
}
const Draft = (props:Props): JSX.Element => {

    /************************************
     *              CONSTANT
     * *********************************/
    /*CONTEXT*/
    const postCtx = useContext(PostContext)
    const languageCtx = useContext(LanguageContext)
    const uiCtx = useContext(UIContext)
    FlowReferences.updateFlow('draft')
    /*---------------------------------------------------------------
    *                       HTTP REQUEST
    * --------------------------------------------------------------*/

    /************************************
     *       DRAFT POST REQUEST API
     * *********************************/
    const draftPostHttp = useHttp<DynamicObject>(configDraftApi)
    const requestTakeActionDraftPost = draftPostHttp.request
    draftPostHttp.request = function (args?: Args) {
        const data = initializeData();

        requestTakeActionDraftPost({
            ...args,
            config: {
                ...args?.config,
                data: {
                    ...args?.config?.data,
                    ...data
                },
                language: languageCtx.language,
                identifier: postCtx.data.step?.identifier,
                workflowId: postCtx.data.workflow_id,
            },
            callbacks: {
                ...args?.callbacks,
                before: () => {
                    uiCtx.setLoading(true)
                }
            }
        })
    }

    /************************************
     *         NEXT REQUEST API
     * *********************************/
    const nextApi = useHttp<DynamicObject>(configNextApi)
    const request = nextApi.request
    nextApi.request = function (args?: Args) {
        const data = initializeData();
        request({
            ...args,
            config: {
                flow_type: postCtx.data.flow_type,
                ...args?.config,
                data: {
                    ...args?.config?.data,
                    ...data
                },
                language: languageCtx.language
            },
            callbacks: {
                ...args?.callbacks,
                before: () => {
                    uiCtx.setLoading(true)
                }
            }
        })
    }

    /*---------------------------------------------------------------
    *                       FUNCTIONS
    * --------------------------------------------------------------*/
    function initializeData() {
        const data: DynamicObject = {
            draftId: postCtx.data.draft_id,
            time_spent_ms: Date.now() - postCtx.data.start_time,
            workflowId: postCtx.data.workflow_id,
            currentStep: postCtx?.data?.step?.identifier,
        }


        for (const key in postCtx.data.currentStepData) {
            data[key as keyof typeof data] = postCtx.data.form[key as keyof typeof postCtx.data.form]
        }
        return data;
    }

    return (
        <div>
            {uiCtx.isLoading && <ComponentLoader/>}
            {
                postCtx.data?.step && !uiCtx.isLoading && <MapperFlow config={postCtx.data.step} nextApi={nextApi} Previous={props.Previous} />
            }

        </div>
    )
}


export default Draft